import PropTypes from "prop-types";

import { Box, Stack, Typography } from "components/core";

import iceCream from "./ice-cream.svg";

const TITLES = ["Oh deary me...", "It’s not you, it’s us...", "Oh crumbs!"];

const MESSAGE_1 = [
  "This is embarassing. Don’t worry our team have been told.",
  "Looks like we’ve run into a slight problem.",
  "This really isn’t supposed to happen. Can you forgive us?",
];

const MESSAGE_2 = [
  "Perhaps try again later or refresh the page, and we can forget this ever happened.",
  "Our team have been told. Perhaps try again later or refresh the page.",
  "Our team have been told. Perhaps try again later or refresh the page.",
];

const ErrorMessage = ({ version, ...rest }) => (
  <Stack alignItems="center" maxWidth="20em" {...rest}>
    <Box component="img" mb={3} role="presentation" src={iceCream} />
    <Typography mb={1} variant="subtitle">
      {TITLES[version]}
    </Typography>
    <Typography mb={1}>{MESSAGE_1[version]}</Typography>
    <Typography>{MESSAGE_2[version]}</Typography>
  </Stack>
);

ErrorMessage.propTypes = {
  version: PropTypes.number.isRequired,
};

export default ErrorMessage;
